import { render, staticRenderFns } from "./InvoicePaymentModal.vue?vue&type=template&id=456bfb15"
import script from "./InvoicePaymentModal.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentModal.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentModal.vue?vue&type=style&index=0&id=456bfb15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports